// import { useMainStore } from '@/stores/main'

// const mainStore = useMainStore()
export const optionsTimestamp = {
    // era: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    // weekday: 'long',
    // timeZone: mainStore.timeZone,
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric'
}


export function parseTimestamp(isoDate) {
    return new Date(isoDate).toLocaleString('ru', optionsTimestamp)
}

export function parseTimestampTime(isoDate) {
    return new Date(isoDate).toLocaleString('ru', {
    // era: 'long',
    // year: 'numeric',
    // month: 'long',
    // day: 'numeric',
    // weekday: 'long',
    // timeZone: mainStore.timeZone,
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric'
})
}

export const optionsDate = {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
}

export function parseDate(isoDate) {
    return new Date(isoDate).toLocaleString('ru', optionsDate)
}